// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1zP8C","header":"MessagesList_header__s_WbT","chat":"MessagesList_chat__21m_q"};